var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.771.002h20.451V0A1.755 1.755 0 0 1 24 1.73v20.538A1.756 1.756 0 0 1 22.222 24H1.771A1.753 1.753 0 0 1 0 22.268V1.732A1.751 1.751 0 0 1 1.771.002Zm1.504 5.366a2.064 2.064 0 1 0 4.128 0 2.064 2.064 0 0 0-4.128 0ZM16.893 20.45h3.556l.001-6.282c0-3.084-.664-5.455-4.268-5.455a3.741 3.741 0 0 0-3.369 1.85h-.047V8.997H9.352v11.452h3.556v-5.665c0-1.494.283-2.941 2.135-2.941 1.826 0 1.85 1.71 1.85 3.037v5.57Zm-9.776 0h-3.56V8.998h3.56V20.45Z",
    fill: "currentColor"
  })));
};
export default SvgLinkedin;